import { render, staticRenderFns } from "./ExpenditureSummary.vue?vue&type=template&id=1ddb5db6"
import script from "./ExpenditureSummary.vue?vue&type=script&lang=js"
export * from "./ExpenditureSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports